<template>
    <div>
        <el-row>
            <el-col :span="24" class="top-title">
                <div>
                    考试中心
                </div>
                <div class="change-class-box">
                    <el-select v-model="form.where.class_guid" placeholder="请选择" @change="changeClass">
                        <el-option
                        v-for="item in classList"
                        :key="item.class_guid"
                        :label="item.class_name"
                        :value="item.class_guid">
                        </el-option>
                    </el-select>
                </div>
            </el-col>
            <el-col :span="18" :offset="3" class="examination-box">
                <el-tabs type="border-card" style="min-height:80vh" @tab-click="clickTabChangeFlag">
                <el-tab-pane label="未完成">
                    <el-row>
                        <div v-if="list.length !== 0">
                            <el-col :span="12" v-for="(item,index) in list" :key="index" >
                                <div class="work-box">
                                    <el-card class="box-card">
                                        <div class="work-title">
                                            {{item.work_name}}
                                        </div>
                                        <el-row>
                                            <el-col :span="6">
                                                <div class="work-img-div">
                                                    <img src="http://foo.ibianma.com/jingying/word/2022/11/30/ef9cbcc85920e58f9a13265a94929bad.png" style="width:70%" alt="">
                                                </div>
                                            </el-col>
                                            <el-col :span="16" class="work-desc">
                                                <div class="work-start-time">
                                                    开始时间：{{item.start_time}}
                                                </div>
                                                <div class="work-end-time">
                                                    结束时间：{{item.end_time}}
                                                </div>
                                                <div class="work-teacher-name">
                                                    {{item.teacher_name}}
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                        
                                            <template>
                                                    <el-popover
                                                        placement="top-start"
                                                        title=""
                                                        width=""
                                                        trigger="hover"
                                                        content="开始答题。">
                                                        <div class="work-show-btn" @click="startWork(item)" slot="reference">
                                                            <i class="el-icon-edit-outline"></i>
                                                        </div>
                                                    </el-popover>
                                                </template>
                                        
                                            </el-col>
                                        </el-row>
                                    </el-card>
                                </div>
                            </el-col>
                        </div>
                        <div v-else>
                            <el-empty description="暂无数据" :image-size="300"></el-empty>
                        </div>

                    </el-row>
                </el-tab-pane>
                <el-tab-pane label="已完成">
                    <el-row>
                        <div v-if="list.length !== 0">
                            <el-col :span="12" v-for="(item,index) in list" :key="index" >
                                <div class="work-box">
                                    <el-card class="box-card">
                                        <div class="work-title">
                                            {{item.work_name}}
                                        </div>
                                        <el-row>
                                            <el-col :span="6">
                                                <div class="work-img-div">
                                                    <img src="http://foo.ibianma.com/jingying/word/2022/11/30/ef9cbcc85920e58f9a13265a94929bad.png" style="width:70%" alt="">
                                                </div>
                                            </el-col>
                                            <el-col :span="16" class="work-desc">
                                                <div class="work-start-time">
                                                    开始时间：{{item.start_time}}
                                                </div>
                                                <div class="work-end-time">
                                                    结束时间：{{item.end_time}}
                                                </div>
                                                <div class="work-teacher-name">
                                                    {{item.teacher_name}}
                                                </div>
                                            </el-col>
                                            <el-col :span="2">
                                                <template>
                                                    <el-popover
                                                        placement="top-start"
                                                        title=""
                                                        width=""
                                                        trigger="hover"
                                                        content="查看报告。">
                                                        <div class="work-show-btn" @click="showReport(item)" slot="reference">
                                                            <i class="el-icon-s-opportunity"></i>
                                                        </div>
                                                    </el-popover>
                                                </template>
                                        
                                            </el-col>
                                        </el-row>
                                    </el-card>
                                    
                            
                                </div>
                            </el-col>
                        </div>
                        <div v-else>
                            <el-empty description="暂无数据" :image-size="300"></el-empty>
                        </div>
          
                    </el-row>
      
                </el-tab-pane>

                </el-tabs>
            </el-col>
        </el-row>
        <Waterfall ref="Waterfall" :dataList = "dataList" :list="list" :form="form"></Waterfall>
    </div>
   
</template>

<script>
    import { homeworkStuList, classMemberList} from '@/api'
    import store from '@/store'
    import Waterfall from '@/components/waterfall'
    export default {
        name: 'Examination',
        components: {
            Waterfall
        },
        props: ['cate', 'words'],
        data() {
            return {
                classPopver:false,
                dialogVisible: false,
                list:[],
                classList:[],
                listForm:{
                        'page':1,
                        'limit':99,
                        'where':{}
                },
                form:{
                    page: 1,
                    limit: 10,
                    where: {
                        work_category_id: '',
                        complete_flag: 'N',
                        time_type: '',
                        class_guid: '',
                        list_type:3
                    }
                }
            }
        },

        computed: {
        },
        methods: {

            dataList(clearFlag)
            {
                if(clearFlag === true)
                {
                    this.list = []
                    this.form.page = 1
                }
                homeworkStuList(this.form).then(response => {
                    if(response.data.length != 0)
                    {
                        this.list = this.list.concat(response.data)
                        this.$refs.Waterfall.isLoading = false
                    }
               
                })
      
            },
            changeClass()
            {

                var class_guid = this.form.where.class_guid
                var userInfo = this.$store.state.user.userInfo
                userInfo.class_guid = class_guid
                
                store.dispatch('user/setUserInfoData', userInfo);
                this.dataList(true)
            },
            classMemberList()
            {
                classMemberList(this.listForm).then(response => {
                    this.classList = response.data
                })
      
            },
            clickTabChangeFlag()
            {
                if(this.form.where.complete_flag == 'Y')
                {
                    this.form.where.complete_flag = 'N'
                }
                else
                {
                    this.form.where.complete_flag = 'Y'
                }
                this.dataList(true)
            },
            changeFormData(){
                this.dataList(true)
            },
            showReport(e)
            {
                if(e.report_list_flag == 'Y')
                {
                    this.$router.push({path:'/viewreport',query: {work_guid:e.work_guid}})
                }
                else
                {
                    this.$notify.success({
                        title: '信息提示',
                        message: e.report_unavailable_msg,
                        duration: 3000
                    })
                }
            },
            startWork(e)
            {
                this.$router.push({path:'/homeworkanswer',query: {work_guid:e.work_guid}})

            }

        },
        mounted() {

            this.form.where.class_guid = this.$route.query.class_guid
            this.dataList()
            this.classMemberList()

        }
    }
</script>
<style scoped lang="less">

    .change-class-box{
        text-align: right;
        padding-right: 14%;
    }
    .top-title{
        text-align: center;
        font-size:24px;
        margin-top:1vh;
    }

    .examination-box{
        margin-top:5vh;
    }

    .work-box{
        padding:30px;
    }


    .work-title{
        font-size:24px;
        padding-bottom:10px;
    }

    .work-start-time{
        margin-top:10px;
    }

    .work-end-time{
        margin-top:10px;
    }

    .work-teacher-name{
        margin-top:10px;
    }

    .work-img-div{
        padding:10px;
    }

    .work-show-btn{
        font-size: 28px;
        color: #409EFF;
        cursor: pointer;
        margin-top: 65px;
    }

    .work-desc{
        font-size:18px;
    }

    @media (max-width: 1400px) {
        .work-desc{
            font-size:14px;
        }
    }

</style>
